import React, { useState } from "react";
import classes from "./Textarea.module.css";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const TextArea = ({
  name,
  value,
  label = "",
  placeholder = "Placeholder",
  isRequired = false,
  onChange,
  id,
  className,
  inputClass,
  style = {},
  errormsg,
  errorStyle = {},
  background = "#FFFFFF",
  borderColor = "#CBD5E1",
  width = "100%",
  labelStyle = {},
  height = "80px",
  resize = "none",
}) => {
  const [text, setText] = useState("");

  // const handleChange = (event) => {
  //   setText(event.target.value);
  // };

  return (
    <>
      <div className={`${classes.inputBox} ${className}`} style={{ ...style }}>
        <label className={classes.inputlabel} style={{ ...labelStyle }}>
          {label}
          {isRequired && (
            <b style={{ color: "#F42820", paddingLeft: "4px" }}>*</b>
          )}
        </label>
        <textarea
          name={name}
          value={value}
          {...(onChange && { onChange: onChange })}
          id={id}
          className={`${classes.inputText} ${inputClass}`}
          placeholder={placeholder}
          style={{
            background,
            border: `1px solid ${borderColor}`,
            width,
            height,
            resize,
          }}
        />
        <label className={classes.error} style={{ ...errorStyle }}>
          {errormsg}
        </label>
      </div>
    </>
  );
};

export default TextArea;
